{
  "bankLogin": {
    "enteringCredentials": "Unos korisničkih podataka...",
    "submittingLogin": "Slanje zahtjeva za prijavu...",
    "twoFaRequired": "Potrebna 2FA autentifikacija za prijavu u banku",
    "twoFaRequiredSms": "Potrebna 2FA autentifikacija — SMS mTAN poslan na telefon",
    "twoFaTimedOut": "Prijava u banku nije uspjela — 2FA istek",
    "twoFaRejected": "Prijava u banku nije uspjela — banka je odbacila 2FA kod",
    "appNotReached": "Prijava u banku nije uspjela — aplikacija se nije učitala nakon 2FA",
    "submittingMtanCode": "Slanje mTAN koda...",
    "successful": "Uspješna prijava u banku",
    "alreadyAuthenticated": "Već ste prijavljeni — koristi se postojeća banka sesija",
    "sessionExpiredRelogin": "Bankina sesija je istekla — ponovno prijava...",
    "credentialsNotConfigured": "Bankovne vjerodajnice nisu konfigurirane",
    "bankTypeNotConfigured": "Tip banke nije konfiguriran"
  },
  "login": {
    "failed": "Prijava nije uspjela"
  },
  "twoFa": {
    "codeTimedOut": "2FA kod nije unesen na vrijeme",
    "codeReceived": "2FA kod primljen",
    "requiredForConfirmation": "Potrebna 2FA autentifikacija za potvrdu plaćanja",
    "codeReceivedSubmitting": "2FA kod primljen, slanje plaćanja...",
    "enterCode": "Unesite 2FA kod",
    "preparingAppium": "Pokretanje Android emulatora i mobilne aplikacije za token — ovo može trajati minutu...",
    "appiumReady": "Android emulator je spreman",
    "fetchingViaAppium": "Zahtijevanje jednokratnog koda iz ASA mobilne aplikacije...",
    "openingMToken": "Otvaram mToken u ASA mobilnoj aplikaciji...",
    "codeReceivedViaAppium": "Jednokratni kod očitao iz ASA mobilne aplikacije",
    "appiumPinNotConfigured": "PIN mobilne aplikacije nije konfigurisan",
    "appiumFailed": "Nije moguće dohvatiti kod iz mobilne aplikacije: {{error}}"
  },
  "payment": {
    "processingInvoice": "Obrada računa: {{addressName}} - {{providerName}} ({{amount}} {{currency}})",
    "failed": "Plaćanje nije uspjelo: {{error}}",
    "complete": "Obrada plaćanja završena. {{successCount}} uspješno, {{failCount}} neuspješno.",
    "cancelledByUser": "Plaćanje otkazano od strane korisnika",
    "alreadyInProgress": "Plaćanje je već u toku",
    "doneSummary": "Obrađeno {{count}} računa",
    "oneOrMoreFailed": "Jedno ili više plaćanja nije uspjelo",
    "processingFailed": "Obrada plaćanja nije uspjela"
  },
  "camofox": {
    "starting": "Pokretanje browsera...",
    "ready": "Browser je spreman"
  },
  "paymentForm": {
    "navigatingDomestic": "Navigacija ka obrascu za domaće plaćanje...",
    "navigatingDomesticTransfer": "Navigacija ka obrascu za domaći transfer...",
    "fillingBeneficiaryDetails": "Popunjavanje podataka o primaocu...",
    "fillingBeneficiaryAccount": "Popunjavanje broja računa primaoca...",
    "fillingBeneficiaryName": "Popunjavanje naziva primaoca...",
    "fillingBeneficiaryAddress": "Popunjavanje adrese primaoca...",
    "proceedingToDetails": "Prelazak na detalje plaćanja...",
    "fillingPaymentDetails": "Popunjavanje detalja plaćanja...",
    "fillingFormDetails": "Popunjavanje detalja obrasca...",
    "enteringAmount": "Unos iznosa plaćanja...",
    "enteringReference": "Unos poziva na broj...",
    "enteringReferenceNote": "Unos poziva na broj (napomena)...",
    "enteringBeneficiaryName": "Unos naziva primaoca...",
    "proceedingToConfirmation": "Prelazak na potvrdu...",
    "waitingForMtan": "Čekanje na mTAN autorizaciju...",
    "enteringMtanCode": "Unos mTAN koda za potvrdu plaćanja...",
    "submittingPaymentOrder": "Slanje naloga za plaćanje...",
    "successful": "Plaćanje uspješno!",
    "orderNotConfirmed": "Plaćanje nije uspjelo — nalog nije potvrđen",
    "paymentFailed": "Plaćanje nije uspjelo",
    "paymentBlocked": "Plaćanje blokirano do verifikacije",
    "amountMismatch": "Nepodudarnost iznosa — očekivano {{expected}}, formular prikazuje {{rendered}}",
    "amountConfirmed": "Iznos plaćanja potvrđen: {{amount}}",
    "allDetailsFilledConfirming": "Svi detalji plaćanja popunjeni, potvrda u toku...",
    "signToastValidated": "Banka potvrdila potpisivanje (notifikacija o uspjehu)",
    "signToastMissing": "Nema potvrde banke — provjeravam u pregledu naloga",
    "tabOrderFound": "Nalog pronađen u {{tab}} ({{rows}} redova)",
    "tabOrderMissing": "Nalog nije u {{tab}} ({{rows}} redova)",
    "leavingStaleForm": "Uklanjanje prethodno ispunjenog obrasca (order {{order}})...",
    "freshFormReady": "Novi prazan obrazac za domaće plaćanje je spreman",
    "orderReadyToSubmit": "Banka je odobrila obrazac — slanje naloga..."
  },
  "mock": {
    "simulationMode": "=== Mock ASA Bank — Režim simulacije ===",
    "loadedInvoices": "Učitano {{count}} tvrdo kodiranih računa za simulaciju.",
    "connectingToBank": "Povezivanje sa ASA Bankom (e.banka.ba)...",
    "amountLabel": "Iznos: {{amount}} {{currency}}",
    "referenceLabel": "Poziv na broj: {{reference}}",
    "beneficiaryLabel": "Primalac: {{beneficiary}}",
    "accountLabel": "Račun: {{account}}"
  },
  "scraping": {
    "noPendingInvoices": "Nema računa na čekanju za plaćanje.",
    "failed": "Skrejpovanje nije uspjelo",
    "testMode": "Pokrenut TESTNI REŽIM plaćanja.",
    "testModeDeprecated": "Testni režim plaćanja je zastario — koristite API za pokretanje plaćanja.",
    "zeroDebtCompleted": "Dug je {{amount}}; {{date}} označeno kao ZAVRŠENO zbog nultog duga.",
    "statusCompleted": "Dug je {{amount}}; {{date}} je već ZAVRŠENO.",
    "statusFailed": "Dug je {{amount}}; {{date}} je u statusu NEUSPJEŠNO. Molimo provjerite ručno.",
    "statusPaid": "Dug je {{amount}}; {{date}} je već PLAĆENO. Čeka se {{providerName}} da procesira.",
    "statusSkipped": "Dug je {{amount}}; {{date}} je PRESKOČENO.",
    "statusProcessing": "Dug je {{amount}}; {{date}} treba platiti.",
    "statusUnknown": "Dug je {{amount}}; {{date}} je u {{status}} statusu.",
    "pendingInvoiceNotReady": "Dug je {{amount}}; {{date}}, račun još nije pripremljen od strane pružatelja.",
    "pendingInvoiceNotDelivered": "Račun još nije isporučen — {{reason}}.",
    "pendingInvoiceNotDeliveredWithDebt": "Dug je {{amount}}; {{date}}, račun još nije isporučen — {{reason}}.",
    "pendingZeroDebt": "Dug je {{amount}}; {{date}} ima nulti dug.",
    "pendingInvoiceDownloaded": "Dug je {{amount}}; {{date}} je nov. Račun preuzet.",
    "pendingInvoiceNoDownload": "Dug je {{amount}}; {{date}} je nov. Preuzimanje računa nije dostupno.",
    "skipPaymentDisabled": "Plaćanje će biti preskočeno jer je onemogućeno.",
    "belowMinimumSkipped": "Dug je {{amount}}, što je ispod minimalnog iznosa računa; {{date}} označeno kao PRESKOČENO.",
    "error": "{{errorMessage}}"
  },
  "scheduler": {
    "noUsersConfigured": "Nema korisnika sa konfigurisanim rasporedom skrejpovanja.",
    "scheduledUser": "Zakazivanje skrejpovanja za korisnika {{name}} u {{time}}",
    "initialized": "Planer inicijaliziran — {{count}} korisnika zakazano.",
    "removed": "Uklonjen skrejper za korisnika {{userId}}.",
    "stopped": "Planer zaustavljen.",
    "invalidTime": "Neispravno vrijeme skrejpovanja \"{{time}}\" za korisnika {{userId}}, preskače se."
  },
  "connection": {
    "failed": "Povezivanje nije uspjelo"
  },
  "appium": {
    "startingInfra": "Pokretanje Appium infrastrukture (emulator + server)..."
  }
}
